module.exports = __webpack_public_path__ + "img/30.b81edc51.webp";